import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import LogsTable from "./LogsTable";
import FullPageLoader from "components/common/FullPageLoader";
import { fetchInterpreterAppointmentView } from "slices/interpreter/appointmentSlice";
import { fetchInterpreterAppointmentLogs } from "slices/interpreter/appointmentSlice";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import toast from "react-hot-toast";
import { CheckinCheckoutAdjustmentModal } from "components/appointment/checkinCheckoutAdjustment";
import CouldNotCover from "components/appointment/CouldNotCover";
import DonotCover from "components/appointment/DonotCover";
import CancelModal from "components/appointment/CancelModal";
import { setActionAssign } from "slices/actionButtonSlice";
import ViewTable from "views/appointment/view/ViewTable";
import { setInterpreterIframeUrl } from "../../../slices/interpreter/interpreterIframeSlice";
import Api from "services/api";
import RecordingModal from "views/JoinRoomCall/RecordingModal";
import { Video } from "lucide-react";
import CasesTable from "./CasesTable";
import { interpreterCheckinCheckout } from "slices/interpreter/appointmentSlice";
import ConfirmationInvitesModal from "components/common/ConfirmationInvites";
import { answerAppointmentInvite } from "slices/interpreter/appointmentSlice";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { cancelJob } from "slices/interpreter/appointmentSlice";
import { setInterpreterActionAssign } from "slices/actionButtonSlice";
import CancellationRequestModal from "components/appointment/CancellationRequestModal";
import moment from "moment";


const AppointmentView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [item, setItem] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const [cancelModal, setCancelModal] = React.useState(false);
  const [cancellationModal, setCancellationModal] = React.useState(false);
  const [answerInviteModal, setAnswerInviteModal] = React.useState('');
  const [donotCover, setDonotCover] = React.useState(false);
  const [couldNotCover, setCouldNotCover] = React.useState(false);
  const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
  const [recordingUrl, setRecordingUrl] = React.useState(null);
  const [showModal, setShowModal] = React.useState(false);

  const callViewApi = async () => {
    const callBack = (success, message, data) => {
      setLoading(false);
      if (success) {
        setItem(data);
        console.log(data);
      } else {
        console.log(message);
      }
    };

    dispatch(fetchInterpreterAppointmentView(id, callBack));
  };

  const fetchLogs = async () => {
    const callBack = (success, message, data) => {
      if (success) {
        setLogs(data);
        console.log(data);
      } else {
        console.log(message);
      }
      // setLogs()
    };
    dispatch(fetchInterpreterAppointmentLogs(id, callBack));
  };

  React.useEffect(() => {
    setLoading(true);
    callViewApi();
    // fetchLogs();
  }, [id]);
  const handleCancel = () => {
    setCancelModal(true);
  };
  const handleCloseCancel = () => {
    setCancelModal(false);
  };
  const handleCancellation = () => {
    setCancellationModal(true);
  };
  const handleCloseCancellation = () => {
    setCancellationModal(false);
  };
  const handleDonotCover = () => {
    setDonotCover(true);
  };
  const handleCloseDonotCover = () => {
    setDonotCover(false);
  };
  const handleCouldNotCover = () => {
    setCouldNotCover(true);
  };
  const handleCloseCouldNotCover = () => {
    setCouldNotCover(false);
  };
  const handleOpenCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(true);
  };
  const handleCloseCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(false);
  };
  const handleSubmit = (data, end_point, callBack) => {
    setLoading(true);
    const submitCallback = (success, message) => {
      callBack && callBack();
      if (success) {
        handleCloseCancel();
        handleCloseCancellation();
        handleCloseDonotCover();
        handleCloseCouldNotCover();
        handleCloseCheckinCheckoutModal();
        callViewApi();
        fetchLogs();
        toast.success(message, {
          className: "successToast",
        });
        if (end_point === "cancel") {
          navigate(`/interpreter/appointments`);
        }
        setLoading(false);
      } else {
        toast.error(message, { className: "errorToast" });
        setLoading(false);
      }
    };
    if (end_point === "adjustment") {
      dispatch(interpreterCheckinCheckout(id, data, submitCallback))
    } else {
      dispatch(setInterpreterActionAssign(id, data, end_point, submitCallback));
    }
  };

  const appointmentId = id;

  //   Join Video Call handler for interpreter
  const handleInterpreterJoinVideoCall = async () => {
    try {
      const response = await Api.interpreterjoinVideoCall(appointmentId);
      if (response?.status === 200) {
        const iframeUrl = response?.data?.data?.iframe_url;
        dispatch(setInterpreterIframeUrl(iframeUrl));
        navigate(`join-room-call`);
        // console.log("Joined successfully:", response);
      } else {
        const errorMsg = response?.data?.statusText || response?.data?.message || response?.data?.error;
        console.error("Failed to join:", errorMsg);
        toast.error(errorMsg, { className: "errorToast" });
      }
    } catch (err) {
      console.error("Error joining video call:", err);
    }
  };

  React.useEffect(() => {
    if (item) {
      console.log("Recording:", item?.appointment_details?.recording);
    } else {
      console.log("Recording not available");
    }
  }, [item]);

  const showRecordingPopup = () => {
    if (item?.appointment_details?.recording) {
      setRecordingUrl(item?.appointment_details?.recording);
      setShowModal(true);
    } else {
      toast.error("Recording not available for this appointment.", {
        className: "errorToast",
      });
    }
  };

  const handleAnswerInvite = (answer) => {
    const submitCallback = (success, message) => {
      if (success) {
        toast.success(message, {
          className: "successToast",
        });
        console.log(answer, "answer")
        if (answer === 'decline') {
          navigate(`/interpreter/appointments`);
        }
        setAnswerInviteModal('');
        callViewApi();
        fetchLogs();
        setLoading(false);
      } else {
        toast.error(message, { className: "errorToast" });
        setLoading(false);
      }
    };
    dispatch(answerAppointmentInvite(item?.id, { answer: answer }, submitCallback))
  };
  const apptInvites = item?.invites ? item?.invites[0] : null;



  const isWithin24Hours = (datetime) => {
    if (!datetime) return false;
    const now = new Date();
    const target = new Date(datetime);
    const diff = target - now;
    return diff <= 24 * 60 * 60 * 1000;
  };

  const isWithin24Hr = isWithin24Hours(item?.datetime);
  const rawDatetime = item?.datetime;

  const parsedDatetime = moment(rawDatetime, "YYYY-MM-DD HH:mm:ss");
  const formattedDate = parsedDatetime.isValid()
    ? parsedDatetime.format("MMM D, YYYY h:mm A") + " (PST)"
    : "";

  return (
    <div className="content" style={{}}>
      {loading && <FullPageLoader />}

      <div className="row_main_head bg-primary-secondaryCard p-3">
        <h2 className={`main_heading main_heading1`}>
          View Job # {item?.appid}
        </h2>
        <h2 className={`main_heading main_heading1`}>
          Status : {item?.status}
        </h2>
      </div>

      <div className="row_main_head bg-light-secondaryCard mt-3">
        <h2 className={`main_heading2 appview`} toLowerCase={"text-lowercase"}>
          Date & Time <span className="dateTime">{formattedDate}</span>
        </h2>
        <h2 className={`main_heading2`} toLowerCase={"text-lowercase"}>
          language <span className="dateTime">{item?.language?.name}</span>
        </h2>
      </div>

      <div className="card_table view_table_custom">
        {(apptInvites?.accepted == 1 && item?.status == "open") &&
          <div className={`softAlert approved`}>
            You have accepted this appointment and it is waiting for approval.
          </div>
        }

        <div className="row-primary flex-wrap justify-content-between">
          <div className="row-primary flex-wrap">
            {(apptInvites?.accepted == 0 && apptInvites?.declined == 0 && item?.status == "open") &&
              <>
                <SubmitButton
                  buttonType="button"
                  btnText="Accept"
                  handleSubmit={() => setAnswerInviteModal('accept')}
                />

                {/* <SubmitButton
                  buttonType="button"
                  className={"tomatoRed"}
                  btnText="Decline"
                  handleSubmit={() => setAnswerInviteModal('decline')}
                /> */}
              </>
            }

            {(item?.status !== "completed" && item?.status !== "cancelled" && item?.status !== "open") && (
              isWithin24Hr ?
                <SubmitButton
                  buttonType="button"
                  className={"tomatoRed"}
                  btnText="Cancellation request"
                  handleSubmit={handleCancellation}
                />
                :
                <SubmitButton
                  buttonType="button"
                  className={"tomatoRed"}
                  btnText="Cancel"
                  handleSubmit={handleCancel}
                />
            )}
            {(item?.status !== "cancelled" && item?.status !== "open" && item?.status !== "completed") && (
              <SubmitButton
                buttonType="button"
                className="Cancle_button"
                btnText="Checkin / checkout"
                data-bs-toggle="modal"
                data-bs-target="#checkinCheckoutAdjustmentModal"
                handleSubmit={handleOpenCheckinCheckoutModal}
              />
            )}
          </div>



          {/* Join Video Call & View Recording Buttons  */}
          {/* <div className="row-primary flex-wrap">
            {item?.appointment_details?.recording && (
              <SubmitButton
                className="Cancle_button"
                btnText="View Recording"
                handleSubmit={showRecordingPopup}
              />
            )}

            {item.type === "VRI" && (
              <SubmitButton
                className="green"
                btnText="Join Video Call"
                icon={<Video />}
                handleSubmit={handleInterpreterJoinVideoCall}
              />
            )}
          </div> */}
        </div>

        {item?.logs?.length > 0 && item?.status !== "cancelled" && item?.status !== "completed" &&  (
          <div className="softAlert" style={{ background: '#fde8e8', borderLeft: '4px solid #dc3545', padding: '12px 16px', margin: '12px 0', borderRadius: 4, color: '#7b1d1d' }}>
            <strong>Cancellation Requested</strong>
            <div style={{ marginTop: 4, fontSize: 14 }}>
              <span>Requested on: {moment(item.logs[0].date + ' ' + item.logs[0].time, 'YYYY-MM-DD hh:mm a').format('MMM D, YYYY h:mm A')}</span>
              {item.logs[0].notes && <div style={{ marginTop: 4 }}>Reason: {item.logs[0].notes}</div>}
            </div>
          </div>
        )}
        <ViewTable item={item} isInterpreter={true} />
      </div>

      <div className="card_table p-4">
        <h2 className="main_heading2 mb-3">Cases</h2>
        <CasesTable cases={item?.cases} onRefresh={callViewApi} />
      </div>

      <CancellationRequestModal
        isOpen={cancellationModal}
        onClose={handleCloseCancellation}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <CancelModal
        isOpen={cancelModal}
        onClose={handleCloseCancel}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <DonotCover
        isOpen={donotCover}
        onClose={handleCloseDonotCover}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <CouldNotCover
        isOpen={couldNotCover}
        onClose={handleCloseCouldNotCover}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <CheckinCheckoutAdjustmentModal
        isOpen={checkinCheckoutModal}
        handleClose={handleCloseCheckinCheckoutModal}
        onConfirm={handleSubmit}
        appointmentId={id}
        onSubmit={handleSubmit}
        item={item}
        loader={loading}
        requireAttestation={true}
      />
      <RecordingModal
        recordingUrl={recordingUrl}
        showModal={showModal}
        onClose={() => setShowModal(false)}
      />

      <ConfirmationInvitesModal
        isOpen={answerInviteModal}
        onClose={() => setAnswerInviteModal(false)}
        onConfirm={(ans) => handleAnswerInvite(ans)}
      />
    </div>
  );
};

export default AppointmentView;
